export const PASSWORD_REGEX = /^(?=.*\d)(?=.*[A-Z])(?=.*\W)[^ ]{6,}$/;
export const EMAIL_REGEX =
  /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*(?:\.[a-zA-Z]{2,})$/;
export const COUPON_CODE = "coupon_code";
export const UTM_PARAMS_COOKIE = "utm_params";

export const LEGACY_FORM_ITEM_CLASS_NAME = "no-padding-top no-margin";

export const getOnboardingButtonVariant = (
  currentCommunity: unknown,
): "branded" | "marketing-gradient-blue" =>
  currentCommunity ? "branded" : "marketing-gradient-blue";
